import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class MobileTearSheet extends Component {
  static propTypes = {
    children: PropTypes.node,
    height: PropTypes.number.isRequired
  };

  static defaultProps = {
    height: 500
  };

  // static contextTypes = {
  //   muiTheme: PropTypes.object.isRequired
  // };

  render() {
    // const { prepareStyles } = this.context.muiTheme;

    const styles = {
      root: {
        boxSizing: 'border-box',
        padding: 24,
        maxWidth: 312,
        width: '100%',
        ...(this.props.style || {})
      },
      container: {
        border: 'solid 1px #d9d9d9',
        borderBottom: 'none',
        // height: this.props.height,
        paddingBottom: 24,
        overflow: 'hidden'
      },
      bottomTear: {
        display: 'block',
        position: 'relative',
        marginTop: -10,
        maxWidth: 360
      }
    };

    return (
      <div style={styles.root}>
        <div style={styles.container}>{this.props.children}</div>
        <img style={styles.bottomTear} src="/images/bottom-tear.svg" />
      </div>
    );
  }
}
